import { keyframes, styled } from '../../stitches.config'

const slideInRight = keyframes({
    from: { left: '100%' },
    to: { left: '0px' },
})

export const BuildACardStep = styled('div', {
    width: 450,
    maxWidth: '100%',
    display: 'none',
    '@media (max-width: 400px)': {
        margin: 'auto',
    },
    '& input, textarea': {
        maxWidth: '100%',
        bc: '$white',
    },
    '& textarea': {
        minHeight: '150px',
    },
    variants: {
        active: {
            true: {
                left: '0px',
                display: 'flex',
                fd: 'column',
                gap: 15,
                animation: `${slideInRight} 200ms`,
            },
        },
    },
})

export const SimpleFieldWrapper = styled('div', {})
